import { useStaticQuery, graphql } from "gatsby"

export default function BookData() {
	const query = graphql`
		query ClanBookData {
			allCclansBookKinshipCsv {
				nodes {
					id
					bibrec
					clanId
					lincurl
					title
				}
			}
			allCclansBookLocalityCsv {
				nodes {
					id
					bibrec
					clanId
					lincurl
					title
				}
			}
		}
	`

	const {
		allCclansBookKinshipCsv,
		allCclansBookLocalityCsv
	} = useStaticQuery(query) || {}

	const kinshipBooks = allCclansBookKinshipCsv.nodes
		.map(book => ({
			...book,
			type: "K"
		}))

	const localityBooks = allCclansBookLocalityCsv.nodes
		.map(book => ({
			...book,
			type: "L"
		}))

	return kinshipBooks.concat(localityBooks)
}
